import React, { useEffect } from 'react';
import { useSelector, useDispatch} from 'react-redux';
import {  useParams } from 'react-router-dom';
import {
  Card,
  Grid,
} from '@material-ui/core';
import { BackdropCircular, Breadcrumb } from 'components';
import {
  getDraftQuotesByCustomerApi,
  getQuoteCustomerDataApi,
  getQuoteProProductsApi
} from 'api';
import EditQuoteListings from './EditQuoteListings';


const EditQuote = () => {
  const dispatch = useDispatch();
  const { userStoreData: {storeCode} } = useSelector((state: IReduxState) => state.user);
  const isCustomer3 = storeCode === 'customer3';
  const { id } = useParams<{ id: string }>();

  const {
    loadingDraftedQuotes,
    currentQuoteCustomer,
    loadingQuoteCustomers,
    loadingCheckout,
    quoteProductsByGroup,
    quoteProductsLoading,
    quoteProducts,
    loadingQuoteProductSubscriptionOptions,
  } = useSelector((state: IReduxState) => state.quote);

  const loading =
    loadingDraftedQuotes ||
    loadingQuoteCustomers ||
    loadingCheckout ||
    loadingQuoteProductSubscriptionOptions ||
    quoteProductsLoading;

  useEffect(() => {
    if (!Object.keys(quoteProductsByGroup).length && !quoteProducts.length) {
      getQuoteProProductsApi({ dispatch });
    }
  }, []);

  useEffect(() => {
    if (!currentQuoteCustomer) {
      getQuoteCustomerDataApi({ dispatch, id });
    }
  }, [currentQuoteCustomer, dispatch, id]);

  useEffect(() => {
    getDraftQuotesByCustomerApi({ dispatch, customerId: id });
  }, []);

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Create Quote', path: '/quoting' },
            { name: `${isCustomer3 ? 'Customer' : 'Patient'} Details`, path: `/quoting/profile/${id}` },
            { name: 'Quote Workspace', path: `/quoting/profile/${id}/quote-workspace` },
            { name: `${isCustomer3 ? 'Customer' : 'Patient'} Activity`, path: `/quoting/profile/${id}/quote-workspace/patient-activity` },
            { name: 'Edit Quote' }
          ]}
        />
      </div>
      <Card className="mx-10 p-8 root-card">
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <EditQuoteListings />
          </Grid>
        </Grid>
      </Card>
      <BackdropCircular loading={loading} />
    </div>
  );
};

export default EditQuote;
